import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { DepInjMixin, requires } from '../../mixins/dependency';
import { QuestionsService } from '../../services/questions-service';
import { commonPopupStyle } from '../../styles/common-style';
import { t } from '../../utils/locale';
import { DeviceAwareComponent } from '../components/device-aware-component';

type Deps = {
  questionsService: QuestionsService;
};

@requires(QuestionsService.serviceName)
@customElement('section-complete-popup')
export class SectionCompletePopup extends DepInjMixin<Deps>(DeviceAwareComponent) {
  static get styles() {
    return [
      commonPopupStyle,
      css`
        #art {
          width: 80%;
          height: 29rem;
        background-image: url(./assets/man-on-boat-popup.svg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
      }
      @media screen and (-webkit-min-device-pixel-ratio: 0) {
        #art {
          -webkit-max-logical-height: 20vh;
          -webkit-margin-before: 1rem;
          -webkit-margin-afdter: 1rem;
        }
      }
      .title,
      .sub-title {
        font-weight: var(--font-weight-emphasize);
      }
      .message {
        color: var(--c-select);
      }
      .message-questions {
        margin: 0;
        padding-block-end: 1rem;
      }
      .second {
        padding-inline: 1.2rem;
        font-size: 1.5rem;
      }
      @media screen and (max-width: 370px) {
        #art {
          height: 25rem;
        }
      }
    `,
    ];
  };

  renderQuestionsStatus() {
    const section = this.deps.questionsService.model.getActiveSectionName();
    if (!section) return;

    const progress = this.deps.questionsService.model.getSectionProgress(
      section,
    );

    const message =
      progress.total == progress.done
        ? t('T_complete_AllQuestions')
        : t('T_complete_MissingQuestions', progress.total - progress.done);
    return html` <h3 class="message-questions">${message}</h3> `;
  }

  render() {
    return html`
      <h1 class="title">${t('T_Complete_Title_SetSails')}</h1>
      <h2 class="sub-title">${t('T_Complete_SubTitle_SetSails')}</h2>
      <div id="art"></div>
      ${this.renderQuestionsStatus()}
      <p class="message">${t('T_Complete_SummaryReminder1')}</p>
      <p class="message second">${t('T_Complete_SummaryReminder2')}</p>
    `;
  }
}
